// extracted by mini-css-extract-plugin
export default {"loading":"ReportBuilder_loading__vlWp8","report-builder":"ReportBuilder_report-builder__i7+vC"};